export const getDateWithOffset = (date: string) => {
    if (Date.parse(date)) {
      var dateWithTimezone = new Date(date);
      var utcOffset = dateWithTimezone.toISOString();
      
      return new Date(utcOffset);
    }
    return null;
  };

export const getLocaleDateWithOffsetString = (date: string) => {
  return getDateWithOffset(date).toLocaleDateString();
};